export default "__VITE_ASSET__CjbdGlSz__"